export default __webpack_public_path__ + "static/media/mobiles.c64aaec1.png";